export default __webpack_public_path__ + "6cad02f9c130d1496ea5f2bd6a5771d0.woff";